import {createSlice} from '@reduxjs/toolkit';
import {apiIsp} from '../../managers/api-manager';

export type IspIsloginSliceState = {};

const initialState: IspIsloginSliceState = {};

const islogin = apiIsp.islogin();

export const apiIspIsloginSlice = createSlice({
  name: 'api-isp-islogin',
  initialState,
  reducers: {},
});

export const apiIspIsloginAction = apiIspIsloginSlice.actions;
export const apiIspIsloginReducer = apiIspIsloginSlice.reducer;
